import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=e36f8884&"
import script from "./BaseCarousel.vue?vue&type=script&lang=js&"
export * from "./BaseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BaseCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports